import React from 'react';
import { HeroCarousel } from '../components/home/HeroCarousel';
import { QuickActionBar } from '../components/home/QuickActionBar';
import { WhyChoose } from '../components/home/WhyChoose';
import { ServicesOverview } from '../components/home/ServicesOverview';
import { AboutSection } from '../components/home/AboutSection';
import { AppointmentSection } from '../components/home/AppointmentSection';
import { MedicalAids } from '../components/home/MedicalAids';
export function Home() {
  return <div className="flex flex-col" data-id="element-713" data-mp="24gijs9n674m8">
      <HeroCarousel data-id="element-714" data-mp="24hk8vi10trmy" />
      <QuickActionBar data-id="element-715" data-mp="24j4taetmfu73" />
      <WhyChoose data-id="element-716" data-mp="29g51owdy191d" />
      <ServicesOverview data-id="element-717" data-mp="29flotu35hau7" />
      <AboutSection data-id="element-718" data-mp="29fc2cghbdlt9" />
      <AppointmentSection data-id="element-719" data-mp="29etxivgl5z9q" />
      <MedicalAids data-id="element-720" data-mp="2dhqfql27rtd5" />
    </div>;
}